import {digitsEnToFa} from 'persian-tools2';
import styled from 'styled-components';

const TimerComponent = ({timerHandler, isRunning, time}) => {
  return (
    <StyledText>
      <div>
        <span onClick={timerHandler}>ارسال دوباره</span>
        {isRunning && <p>{digitsEnToFa(time)}</p>}
      </div>
    </StyledText>
  );
};

export default TimerComponent;

const StyledText = styled.div`
  div {
    position: absolute !important;
    margin-top: 55px !important;
    display: flex !important;
  }

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  color: #707070 !important;
  font-size: 14px !important;

  font-weight: 400 !important;
  p {
    width: 45px !important;
    margin-right: 5px !important;
    margin: 0;
  }
`;
